import { CSSProperties } from "react";
import { Colors, FontSize, Spacing } from "~/jsx/theme";
import { XTypography } from "../design";
import { XLobbyGame } from "./XLobbyGame";
import { LobbyGame } from "~/utils";

export const XLobbyGamesList = ({
  games,
  title,
  style,
}: {
  games: LobbyGame[];
  title: string;
  style?: CSSProperties;
}) => {
  const backgroundColor = "rgb(238, 239, 174, 0.3)";
  const border = `solid 1px ${Colors.common.white}`;
  return (
    <div style={{ paddingTop: 1 }}>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor,
          border,
          borderRadius: 12,
          marginTop: Spacing.px18,
          ...style,
        }}
      >
        <XTypography
          style={{
            marginLeft: Spacing.px12,
            marginTop: "calc(-0.7em - 8px)",
            padding: Spacing.px8,
            backgroundColor: "#5D5742",
            width: "fit-content",
            borderRadius: 8,
            border,
          }}
        >
          {title}
        </XTypography>
        {games.map((game, index) => (
          <XLobbyGame key={game.id} game={game} withOverlay={index % 2 === 1} />
        ))}
        {games.length === 0 && (
          <XTypography
            style={{ padding: Spacing.px12, fontSize: FontSize.px14 }}
          >
            <i>This list is empty</i>
          </XTypography>
        )}
      </section>
    </div>
  );
};
